import React, { useState, useRef, useEffect } from 'react';
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from "@mui/material/TextField";
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { visuallyHidden } from '@mui/utils';

import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CheckIcon from '@mui/icons-material/Check';
import DownloadIcon from '@mui/icons-material/Download';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from '@mui/icons-material/Settings';
import UndoIcon from '@mui/icons-material/Undo';
import UploadIcon from '@mui/icons-material/Upload';

import useAuthAxios from "../../../useAuthAxios";
import LoadingDialog from '../../Loading';
import {
    Input,
    CautionButton,
    NomalButton,
    GrayButton,
    InspectionContents
} from '../../css/CSS.js';

import AccountEditDialog from "./AccountEditDialog"
import AccountManagementImportDialog from './AccountManagementImportDialog';
import AccountManagementImportNoticeDialog from './AccountManagementImportNoticeDialog';
import UnconfirmedCheckDialog from '../UnconfirmedCheckDialog'
import InspectionBreadcrumbs from '../InspectionBreadcrumbs';


const Header = styled(TableRow)({
    backgroundColor: "#289bdf",
});

const Text = styled(Typography)({
    color: "#FFFFFF",
});


export default function AccountManagementBody() {
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth") };

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [list, setList] = useState([]);
    const [baseList, setBaseList] = useState([])

    const inputRef = useRef(null);

    const { control, getValues, setValue } = useForm({
        defaultValues: {
            order: "",
            contractName: "",
            disable: "",
            shitenCD: "",
        },
        mode: 'onChange'
    });
    const [processing_search, setProcessing_search] = useState(false);

    const TableFlame = styled(TableContainer)({
        borderRadius: "10px 10px 0 0",
    });

    const authAxios = useAuthAxios();
    const navigate = useNavigate();

    const [importFileFlg, setImportFileFlg] = useState(false);
    const [errorType, setErrorType] = useState(null);
    const [errorContent, setErrorContent] = useState(null);
    const [importFileLength, setImportFileLength] = useState();
    const [VendorPostInfoList, setVendorPostInfoList] = useState();

    const [editMode, setEditMode] = useState(false);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [operateType, setOperateType] = useState(0)
    const [contractInfo, setContractInfo] = useState({})

    const [processing, setProcessing] = useState(false);
    const [processing_searchReset, setProcessing_searchReset] = useState(false);
    const [shitenSelectList, setShitenSelectList] = useState([]);
    const [shitenList, setShitenList] = useState([]);

    const [deleteChangeList, setDeleteChangeList] = useState([])
    const [unconfirmedDeleteCheck, setUnconfirmedDeleteCheck] = useState(false)
    const [unconfirmedCmd, setUnconfirmedCmd] = useState("")


    const [prevSelectRow, setPrevSelectRow] = useState(null)
    const targetRowRef = useRef(null)
    const [inputKey, setInputKey] = useState(0)

    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = React.useState(0);


    const [noticeOpen, setNoticeOpen] = React.useState(false);

    const handleChangePage = (event, newPage) => {
        const previousCondition = sessionStorage.getItem('vendorAccountSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                pagination: {
                    ...searchConditions.pagination,
                    page: newPage,
                }
            }
            sessionStorage.setItem('vendorAccountSearchCondition', JSON.stringify(newCondition));
        }
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        const previousCondition = sessionStorage.getItem('vendorAccountSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                pagination: {
                    page: 0,
                    pageSize: newPageSize
                }
            }
            sessionStorage.setItem('vendorAccountSearchCondition', JSON.stringify(newCondition));
        }
        setRowsPerPage(newPageSize);
        setPage(0);
    };

    const csvFormat = [
        'contractNo',
        'contractSei',
        'contractMei',
        'email',
        'password',
        'companyName',
        'tantoShisyaCD',
        'tellNumber',
        'delflg',
    ]
    const exportOnClick = () => {
        setProcessing(true);
        let exportText = ""
        csvFormat.forEach((e) => {
            exportText += e + ','
        })
        exportText = exportText.slice(0, -1) + '\n';

        list?.vendorInfoList?.forEach((e) => {
            exportText += e.contractNo + ','
            exportText += e.contractSei + ','
            exportText += e.contractMei + ','
            exportText += e.email + ','
            exportText += e.password + ','
            exportText += e.companyName + ','
            exportText += e.tantoShisyaCD + ','
            exportText += e.tellNumber + ','
            exportText += e.delflg + ','
            exportText += '\n'
        })
        downloadCSV(exportText, "請負業者アカウント一覧_" + new Date().toLocaleDateString("ja-JP", {
            year: "numeric", month: "2-digit",
            day: "2-digit"
        }).replaceAll('/', '-'))
    }

    const downloadCSV = (data, fileName) => {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: "text/csv" });
        const objectUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.download = fileName;
        downloadLink.href = objectUrl;
        downloadLink.click();
        downloadLink.remove();
        setProcessing(false);
    }

    const onFileImport = (e) => {
        const thisFIle = e.target.files;
        const fileExtension = thisFIle[0].name.split('.').pop().toLowerCase()
        if (fileExtension === 'csv') {
            const fileReader = new FileReader();
            fileReader.readAsText(thisFIle[0]);
            fileReader.onload = () => {
                let tmp = fileReader.result.split(/\r\n|\r|\n/);
                var res = [];
                for (let i = 0; i < tmp.length; i++) {
                    if (tmp[i] === '') {
                        break;
                    }
                    res[i] = tmp[i].split(',');
                }
                const keys = res[0];
                let formatError = false;
                let prevContractNo = []
                let requireError = false;
                let DuplicateError = false;
                let ErrorPoint = [];
                for (let i = 0; i < csvFormat.length; i++) {
                    if (csvFormat[i] !== keys[i]) {
                        formatError = true
                    }
                }
                if (formatError) {
                    ErrorPoint = csvFormat
                    setErrorType(0);
                    setErrorContent(ErrorPoint);
                    setImportFileFlg(true);
                } else {
                    const csvData = res.slice(1).map((item) => {
                        let obj = {};
                        keys.forEach((key, i) => (obj[key] = item[i]));
                        return obj;
                    });
                    let count = 0
                    for (let i = 0; i < csvData.length; i++) {
                        //必須項目チェック
                        if (csvData[i][csvFormat[1]] === null || csvData[i][csvFormat[1]] === "") {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[1]] + "は必須項目です。"]
                        } else if (csvData[i][csvFormat[2]] === null || csvData[i][csvFormat[2]] === "") {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[2]] + "は必須項目です。"]
                        } else if (csvData[i][csvFormat[3]] === null || csvData[i][csvFormat[3]] === "") {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[3]] + "は必須項目です。"]
                        } else if (csvData[i][csvFormat[0]] &&
                            csvData[i][csvFormat[0]] !== "" &&
                            (csvData[i][csvFormat[4]] === null || csvData[i][csvFormat[4]] === "")) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[4]] + "は必須項目です。"]
                        } else if (csvData[i][csvFormat[6]] === null || csvData[i][csvFormat[6]] === "") {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[6]] + "は必須項目です。"]
                        } else if (csvData[i][csvFormat[7]] === null || csvData[i][csvFormat[7]] === "") {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[7]] + "は必須項目です。"]
                        }
                        if (requireError) { break }
                        //文字チェック
                        count = 0
                        for (let j = 0; j < csvData[i][csvFormat[0]].length; j++) {
                            if (csvData[i][csvFormat[0]][j].match(/^[^ -~｡-ﾟ]/)) { // 全角半角判定
                                requireError = true
                                ErrorPoint = [i + 1, [csvFormat[0]] + "は半角10文字以内で入力してください。"]
                                break
                            } else {
                                count += 1
                            }
                        }
                        if (requireError) {
                            break
                        } else {
                            if (count > 10) {
                                requireError = true
                                ErrorPoint = [i + 1, [csvFormat[0]] + "は半角10文字以内で入力してください。"]
                                break
                            }
                        }
                        count = 0
                        for (let j = 0; j < csvData[i][csvFormat[1]].length; j++) {
                            if (csvData[i][csvFormat[1]][j].match(/^[^ -~｡-ﾟ]/)) { // 全角半角判定
                                count += 1
                            } else {
                                count += 0.5
                            }
                        }
                        if (count > 10) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[1]] + "は全角10文字もしくは半角20文字以内で入力してください。"]
                            break
                        }
                        count = 0
                        for (let j = 0; j < csvData[i][csvFormat[2]].length; j++) {
                            if (csvData[i][csvFormat[2]][j].match(/^[^ -~｡-ﾟ]/)) { // 全角半角判定
                                count += 1
                            } else {
                                count += 0.5
                            }
                        }
                        if (count > 10) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[2]] + "は全角10文字もしくは半角20文字以内で入力してください。"]
                            break
                        }
                        if (csvData[i][csvFormat[3]].length > 255) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[3]] + "は半角255文字以内で入力してください。"]
                            break
                        }
                        if (!csvData[i][csvFormat[3]].match(/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/)) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[3]] + "はXXX@XXXで入力してください。"]
                            break
                        }
                        if (csvData[i][csvFormat[4]].length > 20) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[4]] + "は半角20文字以内で入力してください。"]
                            break
                        }
                        if (csvData[i][csvFormat[0]] &&
                            csvData[i][csvFormat[0]] !== "" &&
                            !csvData[i][csvFormat[4]].match(/^[\x20-\x7E]+$/)) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[4]] + "は半角文字で入力してください。"]
                            break
                        }
                        count = 0
                        for (let j = 0; j < csvData[i][csvFormat[5]].length; j++) {
                            if (csvData[i][csvFormat[5]][j].match(/^[^ -~｡-ﾟ]/)) { // 全角半角判定
                                count += 1
                            } else {
                                count += 0.5
                            }
                        }
                        if (count > 20) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[5]] + "は全角20文字もしくは半角40文字以内で入力してください。"]
                            break
                        }
                        for (let j = 0; j < shitenList.shitenInfo.length; j++) {
                            if (csvData[i][csvFormat[6]] === shitenList.shitenInfo[j].shitenCD) {
                                break
                            }
                            if (j === shitenList.shitenInfo.length - 1) {
                                requireError = true
                                ErrorPoint = [i + 1, "指定の" + [csvFormat[6]] + "は未登録です。"]
                                break
                            }
                        }
                        if (csvData[i][csvFormat[7]].length > 15) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[7]] + "は半角15文字以内で入力してください。"]
                            break
                        }
                        if (!csvData[i][csvFormat[7]].match(/^[0-9-]+$/)) {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[7]] + "は半角数字と半角ハイフンのみで入力してください。"]
                            break
                        }
                        if (csvData[i][csvFormat[8]] === "0" || csvData[i][csvFormat[8]] === "1") {
                            csvData[i][csvFormat[8]] = Number(csvData[i][csvFormat[8]])
                        } else {
                            requireError = true
                            ErrorPoint = [i + 1, [csvFormat[8]] + "は「0」もしくは「1」を入力してください。"]
                            break
                        }
                        if (requireError) { break }
                        //重複チェック
                        if (i !== 0) {
                            for (let j = 0; j < prevContractNo.length; j++) {
                                if (csvData[i][csvFormat[0]] === prevContractNo[j] && prevContractNo[j] !== "") {
                                    DuplicateError = true
                                    ErrorPoint = [prevContractNo[j], j + 1, i + 1]
                                }
                                if (DuplicateError) {
                                    break
                                }
                            }
                        }
                        if (DuplicateError) {
                            break
                        }
                        prevContractNo.push(csvData[i][csvFormat[0]]);
                    }
                    if (requireError) {
                        setErrorType(1);
                        setErrorContent(ErrorPoint);
                        setImportFileFlg(true);
                    } else if (DuplicateError) {
                        setErrorType(2);
                        setErrorContent(ErrorPoint);
                        setImportFileFlg(true);
                    } else if (csvData.length === 0) {
                        alert("取得するデータがありません。");
                    } else {
                        setErrorType(null);
                        setErrorContent(null);
                        setImportFileLength(csvData.length);
                        setVendorPostInfoList(csvData);
                        setImportFileFlg(true);
                    }
                }
            }
        } else {
            alert("csvファイルを指定してください。");
        }
        setInputKey((prevKey) => prevKey + 1)
    }

    const importCancelClick = () => {
        setImportFileFlg(false)
    }

    const importConfirmClick = () => {
        setProcessing(true);
        VendorPostInfoList.forEach((item) => {
            if (item.contractNo === "" && item.password === "") {
                item.defaultPasswordUse = 1
            }
        })
        authAxios
            .post('api/inspection/inspectionVendor', { VendorPostInfoList })
            .then(response => {
                if (response.status === 200) {
                    authAxios
                        .get('api/inspection/inspectionVendors?contractName=' + getValues('contractName') + '&shitenCD=' + getValues("shitenCD"), { headers })
                        .then(response => {
                            if (response.status === 200) {
                                const listdata = JSON.parse((JSON.stringify(response.data)));
                                setList(listdata)
                                setBaseList(listdata)
                                setProcessing(false)
                                setImportFileFlg(false)
                                setNoticeOpen(false);
                            } else if (response.status === 401) {
                                alert("認証に失敗しました。");
                                setProcessing_search(false)
                                switch (localStorage.getItem("loginType")) {
                                    case "0":
                                        navigate("/");
                                        break
                                    case "1":
                                        navigate("/omsuser");
                                        break
                                    case "2":
                                        navigate("/vender");
                                        break
                                    default:
                                        navigate("/");
                                }
                            }
                        })
                        .catch((response) => {
                            alert("一覧情報取得に失敗しました。", response.body);
                            setProcessing(false)
                        });
                }
            })
            .catch((response) => {
                alert("登録に失敗しました。", response.body);
                setProcessing(false)
            });
    }

    const contractSearchClick = () => {
        if (editMode) {
            if (deleteChangeList.length > 0) {
                setUnconfirmedDeleteCheck(true);
                setUnconfirmedCmd("search");
            } else {
                contractSearch();
            }
        } else {
            contractSearch();
        }
    }

    const contractSearch = () => {
        setProcessing_search(true);
        authAxios
            .get('api/inspection/inspectionVendors?contractName=' + getValues('contractName') + '&shitenCD=' + getValues("shitenCD"), { headers })
            .then(response => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    setPage(0)
                    setList(listdata)
                    setBaseList(listdata)
                    const vendorAccountSearchCondition = {
                        contractName: getValues("contractName"),
                        shitenCD: getValues("shitenCD"),
                        pagination: {
                            page: 0,
                            pageSize: rowsPerPage
                        },
                        sort: {
                            order: 'asc',
                            orderBy: '',
                        }
                    }
                    sessionStorage.setItem('vendorAccountSearchCondition', JSON.stringify(vendorAccountSearchCondition));
                    setProcessing_search(false)
                } else if (response.status === 401) {
                    alert("認証に失敗しました。");
                    setProcessing_search(false)
                    switch (localStorage.getItem("loginType")) {
                        case "0":
                            navigate("/");
                            break
                        case "1":
                            navigate("/omsuser");
                            break
                        case "2":
                            navigate("/vender");
                            break
                        default:
                            navigate("/");
                    }
                }
            })
            .catch((response) => {
                alert("一覧情報取得に失敗しました。", response.body);
                setProcessing_search(false)
            });
    }

    const contractResetClick = () => {
        if (editMode) {
            if (deleteChangeList.length > 0) {
                setUnconfirmedDeleteCheck(true);
                setUnconfirmedCmd("reset");
            } else {
                contractReset();
            }
        } else {
            contractReset();
        }
    }

    const contractReset = () => {
        setProcessing_searchReset(true);
        setValue("contractName", "");
        setValue("shitenCD", "");
        setList([]);
        setBaseList([]);
        sessionStorage.removeItem('vendorAccountSearchCondition');
        setProcessing_searchReset(false);
    }
    const UnconfirmedCancelClick = () => {
        setUnconfirmedDeleteCheck(false);
    }

    const editModeOnClick = () => {
        if (editMode) {
            if (deleteChangeList.length > 0) {
                setUnconfirmedDeleteCheck(true);
                setUnconfirmedCmd("modeChange");
            } else {
                setEditMode(false);
            }
        } else {
            setEditMode(true);
        }
    }
    const onClickToPropAssignment = () => {
        if (editMode) {
            if (deleteChangeList.length > 0) {
                setUnconfirmedDeleteCheck(true);
                setUnconfirmedCmd("moveToPropAssignment");
            } else {
                toPropAssignment()
            }
        } else {
            toPropAssignment()
        }
    }

    const toPropAssignment = () => {
        navigate("/inspection/propertyAssignment/list");
    }

    const onClickToBack = () => {
        if (editMode) {
            if (deleteChangeList.length > 0) {
                setUnconfirmedDeleteCheck(true);
                setUnconfirmedCmd("moveToBack");
            } else {
                moveToBack()
            }
        } else {
            moveToBack()
        }
    }

    const moveToBack = () => {
        navigate("/inspection");
    }

    const UnconfirmedExeClick = () => {
        setDeleteChangeList([])
        if (unconfirmedCmd === "search") {
            contractSearch()
        } else if (unconfirmedCmd === "reset") {
            contractReset()
        } else if (unconfirmedCmd === "modeChange") {
            setList(baseList);
            setEditMode(false);
        } else if (unconfirmedCmd === "moveToPropAssignment") {
            toPropAssignment()
        } else if (unconfirmedCmd === "moveToBack") {
            moveToBack();
        }
        setUnconfirmedDeleteCheck(false);
    }

    React.useEffect(() => {
        //初期表示時
        if (shitenList.length === 0) return;
        //支店リストセット完了後
        const previousCondition = sessionStorage.getItem('vendorAccountSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            setValue("contractName", searchConditions.contractName);
            setValue("shitenCD", searchConditions.shitenCD);
            setProcessing(true)
            authAxios
                .get('api/inspection/inspectionVendors?contractName=' + getValues('contractName') + '&shitenCD=' + getValues("shitenCD"), { headers })
                .then(response => {
                    if (response.status === 200) {
                        const listdata = JSON.parse((JSON.stringify(response.data)));
                        const sortedListData =  {
                            ...listdata,
                            vendorInfoList: stableSort(listdata?.vendorInfoList, getComparator(searchConditions.sort.order, searchConditions.sort.orderBy))
                        }
                        setRowsPerPage(searchConditions.pagination.pageSize);
                        setPage(searchConditions.pagination.page);
                        setList(sortedListData)
                        setProcessing(false)
                    } else if (response.status === 401) {
                        alert("認証に失敗しました。");
                        setProcessing(false)
                        switch (localStorage.getItem("loginType")) {
                            case "0":
                                navigate("/");
                                break
                            case "1":
                                navigate("/omsuser");
                                break
                            case "2":
                                navigate("/vender");
                                break
                            default:
                                navigate("/");
                        }
                    }
                })
                .catch((response) => {
                    alert("一覧情報取得に失敗しました。", response.body);
                    setProcessing(false)
                });
        } else {
            if (localStorage.getItem("UserShitenCD")) {
                const defaultShitenCD = localStorage.getItem("UserShitenCD");
                const target = shitenSelectList.find(item => item.shitenCD === defaultShitenCD);
                setValue("shitenCD", target ? target.shitenCD : "");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shitenList]);

    React.useLayoutEffect(() => {
        setProcessing(true)
        authAxios
            .get('api/inspection/inspectionVendor/offices', { headers })
            .then(response => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    setShitenList(listdata)
                    const selectList = [];
                    selectList.push({ shitenCD: "", shitenName: "未選択" })
                    listdata.shitenInfo.forEach((e) => selectList.push({ shitenCD: e.shitenCD, shitenName: e.shitenName }))
                    setShitenSelectList(selectList)
                    setProcessing(false);
                }
            }).catch((response) => {
                alert("支店情報取得に失敗しました。", response.body);
                switch (localStorage.getItem("loginType")) {
                    case "0":
                        navigate("/");
                        break
                    case "1":
                        navigate("/omsuser");
                        break
                    case "2":
                        navigate("/vender");
                        break
                    default:
                        navigate("/");
                }
                setProcessing(false)
            });
        setProcessing(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openNewEntry = () => {
        setOperateType(0)
        setContractInfo("")
        setShowEditDialog(true)
    }

    const editOnClick = (row) => {
        setOperateType(1)
        setContractInfo(row)
        setShowEditDialog(true)
    }

    const editDialogCloseClick = () => {
        setShowEditDialog(false)
    }

    const editDialogConfirmClick = () => {
        setShowEditDialog(false)
        setProcessing(true)
        authAxios
            .get('api/inspection/inspectionVendors?contractName=' + getValues('contractName') + '&shitenCD=' + getValues("shitenCD"), { headers })
            .then(response => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    setList(listdata)
                    setBaseList(listdata)
                    setProcessing(false)
                } else if (response.status === 401) {
                    alert("認証に失敗しました。");
                    setProcessing_search(false)
                    switch (localStorage.getItem("loginType")) {
                        case "0":
                            navigate("/");
                            break
                        case "1":
                            navigate("/omsuser");
                            break
                        case "2":
                            navigate("/vender");
                            break
                        default:
                            navigate("/");
                    }
                }
            })
            .catch((response) => {
                alert("一覧情報取得に失敗しました。", response.body);
                setProcessing(false)
            });
    }

    const deleteOnClick = (row) => {
        setPrevSelectRow(row.contractNo)
        const newList = JSON.parse((JSON.stringify(list)));
        const targetRow = newList?.vendorInfoList.find((item) => item.contractNo === row.contractNo)
        if (!targetRow.color) {
            if (targetRow.delflg === 1) {
                targetRow.color = "#81BDDF"
            } else {
                targetRow.color = "#DF8F8F"
            }
            setDeleteChangeList([...deleteChangeList, {
                contractNo: row.contractNo,
                delflg: row.delflg === 1 ? 0 : 1
            }])
        } else {
            setDeleteChangeList(
                deleteChangeList.filter((tar) => (tar.contractNo !== row.contractNo))
            )
            delete targetRow.color
        }
        setList(newList)
    }
    const noticeClose = () => {
        setNoticeOpen(false);
    }
    const importOnClick = () => {
        setNoticeOpen(true);
    }

    const deleteConfirm = () => {
        if (!deleteChangeList.length > 0) {
            alert("変更内容がありません。")
            return
        }
        setProcessing(true)
        const VendorDeleteOrRepairList = deleteChangeList
        authAxios
            .post('api/inspection/inspectionVendor/delete', { VendorDeleteOrRepairList }, { headers })
            .then(response => {
                if (response.status === 200) {
                    setDeleteChangeList([])
                    authAxios
                        .get('api/inspection/inspectionVendors?contractName=' + getValues('contractName') + '&shitenCD=' + getValues("shitenCD"), { headers })
                        .then(response => {
                            if (response.status === 200) {
                                const listdata = JSON.parse((JSON.stringify(response.data)));
                                setBaseList(listdata)
                                setList(listdata)
                                setProcessing(false)
                            } else if (response.status === 401) {
                                alert("認証に失敗しました。");
                                setProcessing(false)
                                switch (localStorage.getItem("loginType")) {
                                    case "0":
                                        navigate("/");
                                        break
                                    case "1":
                                        navigate("/omsuser");
                                        break
                                    case "2":
                                        navigate("/vender");
                                        break
                                    default:
                                        navigate("/");
                                }
                            }
                        })
                        .catch((response) => {
                            alert("一覧情報取得に失敗しました。", response.body);
                            setProcessing(false)
                        });
                }
            }
            ).catch((response) => {
                alert("請負担当者アカウントの削除復元に失敗しました。", response.body);
                setProcessing(false)
            });
    }

    const contractOnClick = (row) => {
        navigate("/inspection/propertyAssignment/list", {
            state: {
                contractInfo: row
            }
        });
    }

    useEffect(() => {
        if (targetRowRef.current) {
            targetRowRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [prevSelectRow])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        const previousCondition = sessionStorage.getItem('vendorAccountSearchCondition');
        if (previousCondition) {
            const searchConditions = JSON.parse(previousCondition);
            const newCondition = {
                ...searchConditions,
                sort: {
                    order: isAsc ? 'desc' : 'asc',
                    orderBy: property,
                }
            }
            sessionStorage.setItem('vendorAccountSearchCondition', JSON.stringify(newCondition));
        }
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function stableSort(array, comparator) {
        const stabilizedThis = array?.map((el, index) => [el, index]);
        stabilizedThis?.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis?.map((el) => el[0]);
    }

    const headCells = [
        {
            id: 'edit',
            label: '修正',
            align: 'center',
            width: '6%',
        },
        {
            id: 'contractNo',
            label: '請負者No',
            align: 'left',
            width: '9%',
        },
        {
            id: 'contractName',
            label: '氏名',
            align: 'left',
            width: '12%',
        },
        {
            id: 'email',
            label: 'メールアドレス',
            align: 'left',
            width: '15%',
        },
        {
            id: 'companyName',
            label: '会社名',
            align: 'left',
            width: '10%',
        },
        {
            id: 'tantoShisyaName',
            label: '担当支店',
            align: 'left',
            width: '10%',
        },

        {
            id: 'tellNumber',
            label: '電話番号',
            align: 'left',
            width: '10%',
        },
        {
            id: 'validDate',
            label: '有効化日',
            align: 'left',
            width: '10%',
        },
        {
            id: 'lastLoginDate',
            label: 'ログイン日',
            align: 'left',
            width: '10%',
        }
    ];
    const headDeleteCells = [
        {
            id: 'edit',
            label: '削除',
            align: 'center',
            width: '6%',
        },
        {
            id: 'contractNo',
            label: '請負者No',
            align: 'left',
            width: '9%',
        },
        {
            id: 'contractName',
            label: '氏名',
            align: 'left',
            width: '12%',
        },
        {
            id: 'email',
            label: 'メールアドレス',
            align: 'left',
            width: '15%',
        },
        {
            id: 'companyName',
            label: '会社名',
            align: 'left',
            width: '10%',
        },
        {
            id: 'tantoShisyaName',
            label: '担当支店',
            align: 'left',
            width: '10%',
        },

        {
            id: 'tellNumber',
            label: '電話番号',
            align: 'left',
            width: '10%',
        },
        {
            id: 'validDate',
            label: '有効化日',
            align: 'left',
            width: '10%',
        },
        {
            id: 'lastLoginDate',
            label: 'ログイン日',
            align: 'left',
            width: '10%',
        }
    ];
    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };

        return (
            <TableHead >
                <Header>
                    {!props.mode ?
                        headCells.map((headCell) => (
                            <TableCell
                                key={headCell.id}
                                align={headCell.align}
                                width={headCell.width}
                                sortDirection={orderBy === headCell.id ? order : false}
                                sx={{ backgroundColor: "#289bdf" }}
                            >
                                {(headCell.id === "contractNo" ||
                                    headCell.id === "contractName" ||
                                    headCell.id === "tantoShisyaName" ||
                                    headCell.id === "validDate" ||
                                    headCell.id === "lastLoginDate") ?
                                    <TableSortLabel
                                        active={orderBy === headCell.id}
                                        direction={orderBy === headCell.id ? order : 'asc'}
                                        onClick={createSortHandler(headCell.id)}
                                    >
                                        <Text sx={{ color: props.mode === true ? "#000000" : "#FFFFFF" }}>{headCell.label}</Text>
                                        {orderBy === headCell.id ? (
                                            <Box component="span" sx={visuallyHidden}>
                                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        ) : null}
                                    </TableSortLabel>
                                    :
                                    <div>
                                        <Text sx={{ color: props.mode === true ? "#000000" : "#FFFFFF" }}>{headCell.label}</Text>
                                        {orderBy === headCell.id ? (
                                            <Box component="span" sx={visuallyHidden}>
                                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        ) : null}
                                    </div>
                                }
                            </TableCell>
                        ))
                        :

                        headDeleteCells.map((headCell) => (
                            <TableCell
                                key={headCell.id}
                                align={headCell.align}
                                width={headCell.width}
                                sortDirection={orderBy === headCell.id ? order : false}
                                sx={{ backgroundColor: "#C0C0C0" }}
                            >
                                {(headCell.id === "contractNo" ||
                                    headCell.id === "contractName" ||
                                    headCell.id === "tantoShisyaName" ||
                                    headCell.id === "validDate" ||
                                    headCell.id === "lastLoginDate") ?
                                    <TableSortLabel
                                        active={orderBy === headCell.id}
                                        direction={orderBy === headCell.id ? order : 'asc'}
                                        onClick={createSortHandler(headCell.id)}
                                    >
                                        <Text sx={{ color: props.mode === true ? "#000000" : "#FFFFFF" }}>{headCell.label}</Text>
                                        {orderBy === headCell.id ? (
                                            <Box component="span" sx={visuallyHidden}>
                                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        ) : null}
                                    </TableSortLabel>
                                    :
                                    <div>
                                        <Text sx={{ color: props.mode === true ? "#000000" : "#FFFFFF" }}>{headCell.label}</Text>
                                        {orderBy === headCell.id ? (
                                            <Box component="span" sx={visuallyHidden}>
                                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                            </Box>
                                        ) : null}
                                    </div>
                                }
                            </TableCell>
                        ))
                    }
                </Header>
            </TableHead >
        );
    }

    EnhancedTableHead.propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number,
    };

    return (
        <InspectionContents style={{ marginLeft: 0, marginRight: 0 }} maxWidth="xl">
            <LoadingDialog load={processing} />
            <AccountManagementImportDialog
                open={importFileFlg}
                errorType={errorType}
                errorContent={errorContent}
                importFileLength={importFileLength}
                cancelClick={importCancelClick}
                confirmClick={importConfirmClick}
            />
            <AccountManagementImportNoticeDialog
                open={noticeOpen}
                inputKey={inputKey}
                inputRef={inputRef}
                closeClick={noticeClose}
                onFileImport={onFileImport}
            />
            <AccountEditDialog
                open={showEditDialog}
                operateType={operateType}
                contractInfo={contractInfo}
                shitenList={shitenList.shitenInfo}
                closeClick={editDialogCloseClick}
                confirmClick={editDialogConfirmClick}
            />
            <UnconfirmedCheckDialog
                open={unconfirmedDeleteCheck}
                cancelClick={() => UnconfirmedCancelClick()}
                exeClick={() => UnconfirmedExeClick()} />
            <InspectionBreadcrumbs />
            <Grid container
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 1
                }}>
                <Grid item xs={6}>
                    <Typography variant='h5' sx={{ px: "1vw" }}>条件を指定して検索ボタンを押してください。</Typography>
                    <Typography variant='h5' sx={{ px: "1vw" }}>何も条件を指定しないと全件検索になります。</Typography>
                </Grid>
                <Grid item xs={6}>
                    {!editMode ?
                        <Grid container sx={{ px: "1vw" }}>
                            <Grid container direction="row" spacing={2} sx={{ py: 1 }}>
                                <Grid item xs={6} sx={{ textAlign: 'center' }} >
                                    <NomalButton variant="contained" sx={{ fontSize: '1.2rem', py: 1, width: "100%" }}
                                        onClick={() => openNewEntry()}>
                                        <PersonAddIcon sx={{ mr: 1 }} />
                                        新規登録
                                    </NomalButton>
                                </Grid>
                                <Grid item xs={6} sx={{ textAlign: 'center' }} >
                                    <GrayButton variant="contained"
                                        sx={{ fontSize: '1.2rem', py: 1, width: "100%" }}
                                        onClick={() => editModeOnClick()}>
                                        <SettingsIcon sx={{ mr: 1 }} />
                                        削除/復元
                                    </GrayButton>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" spacing={2} sx={{ py: 1 }}>
                                <Grid item xs={6} sx={{ textAlign: 'center' }} >
                                    <NomalButton variant="contained"
                                        sx={{ fontSize: '1.2rem', py: 1, width: "100%" }}
                                        onClick={() => importOnClick()}>
                                        <UploadIcon sx={{ mr: 1 }} /> インポート一括登録
                                    </NomalButton>
                                </Grid>
                                <Grid item xs={6} sx={{ textAlign: 'center' }} >
                                    <NomalButton variant="contained"
                                        sx={{ fontSize: '1.2rem', py: 1, width: "100%" }}
                                        onClick={() => exportOnClick()}>
                                        <DownloadIcon sx={{ mr: 1 }} />  エクスポート
                                    </NomalButton>
                                </Grid>
                            </Grid>
                        </Grid>
                        :
                        <Grid container sx={{ px: "1vw", }}>
                            <Grid container direction="row" spacing={2} sx={{ py: 1, justifyContent: "flex-end", }}>
                                <Grid item xs={6} sx={{ textAlign: 'center' }} >
                                    <GrayButton variant="contained"
                                        sx={{ fontSize: '1.2rem', py: 1, width: "100%" }}
                                        onClick={() => editModeOnClick()}>
                                        <SettingsIcon sx={{ mr: 1 }} />
                                        削除/復元モード終了
                                    </GrayButton>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" spacing={2} sx={{ py: 1, justifyContent: "flex-end", }}>
                                <Grid item xs={6} sx={{ textAlign: 'center' }} >
                                    <NomalButton variant="contained"
                                        sx={{ fontSize: '1.2rem', py: 1, width: "100%" }}
                                        onClick={() => deleteConfirm()}>
                                        <CheckIcon sx={{ mr: 1 }} />
                                        確定
                                    </NomalButton>
                                </Grid>
                            </Grid>
                        </Grid>}
                </Grid>
            </Grid>
            <Grid sx={{ mt: 3, px: "1vw" }}>
                <Grid container rowSpacing={1} columnSpacing={2}>
                    <Grid item xs="auto">
                        <SearchIcon />
                        <Controller
                            control={control}
                            name="contractName"
                            render={({ field, fieldState }) =>
                                <TextField
                                    {...field}
                                    variant="standard"
                                    label="氏名"
                                    error={fieldState.invalid}
                                    inputProps={{ maxLength: 15, }}
                                />
                            }
                        />
                    </Grid>
                    <Grid item xs="auto" >
                        <SearchIcon />
                        <Controller
                            control={control}
                            name="shitenCD"
                            render={({ field, fieldState }) => (
                                <FormControl error={fieldState.invalid} >
                                    <InputLabel id="area-label">支店</InputLabel>
                                    <Select
                                        labelId="shiten-label"
                                        label="支店"
                                        variant="standard"
                                        sx={{ width: 150 }}
                                        {...field}
                                    >
                                        {shitenSelectList.map((row, index) => {
                                            return (
                                                <MenuItem key={index} value={row.shitenCD}>{row.shitenName}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                    <FormHelperText>{fieldState.error?.message}</FormHelperText>
                                </FormControl>
                            )}
                        />
                    </Grid>
                    <Grid item xs="auto" >
                        <NomalButton
                            className="confButton"
                            type="submit"
                            variant="contained"
                            onClick={() => contractSearchClick()}
                            sx={{ fontSize: '1.2rem', px: 4, py: 1, mx: 2 }}
                            disabled={processing_search}
                        ><SearchIcon sx={{ mr: 1 }} />
                            {processing_search ? "検索中" : "検索"}
                        </NomalButton>
                        <LoadingDialog load={processing_search} />
                    </Grid>
                    <Grid item xs="auto">
                        <CautionButton
                            type="button"
                            sx={{ fontSize: '1.2rem', px: 4, py: 1, mx: 2 }}
                            disabled={processing_searchReset}
                            onClick={() => contractResetClick()}
                        ><RefreshIcon sx={{ mr: 1 }} />
                            {processing_searchReset ? "リセット中" : "検索条件リセット"}
                        </CautionButton>
                        <LoadingDialog load={processing_searchReset} />
                    </Grid>

                </Grid>
            </Grid>

            <TableFlame sx={{ mt: 3, mb: 5, mx: "1vw", maxWidth: "98vw" }}>
                <Table
                    align="center"
                    stickyHeader
                >
                    <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={list?.vendorInfoList?.length}
                        mode={editMode}
                    />
                    <TableBody>
                        {stableSort(list?.vendorInfoList, getComparator(order, orderBy))
                            ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            ?.map((row, index) => {
                                return (
                                    <TableRow
                                        key={index}
                                        tabIndex={-1}
                                        ref={row.contractNo === prevSelectRow ? targetRowRef : null}
                                        sx={{
                                            backgroundColor: !editMode ?
                                                row.delflg === 1 ? "#C0C0C0" : null
                                                : row.color ? row.color : null,
                                            "&:hover": {
                                                backgroundColor: !editMode ?
                                                    row.delflg === 1 ? "#a9a9a9" : "#ededed"
                                                    : !row.color ? "#ededed" :
                                                        row.delflg === 1 ? "#70A2C1" : "#C07B7B",
                                            },
                                        }}
                                        //selected={row.contractNo === prevSelectRow}
                                        onClick={editMode ? () => deleteOnClick(row) : null}
                                    >
                                        {!editMode ?
                                            row.delflg === 0 ?
                                                <TableCell align="center" width="6%" sx={{ pr: 0 }}
                                                    onClick={() => editOnClick(row)}>
                                                    <Button>
                                                        <PersonSearchIcon sx={{ color: "#289bdf" }} />
                                                    </Button>
                                                </TableCell>
                                                :
                                                <TableCell align="center" width="6%" sx={{ pr: 0 }}>

                                                </TableCell>
                                            :
                                            !row.color ?
                                                row.delflg === 0 ?
                                                    <TableCell align="center" width="6%" sx={{ pr: 0 }}>
                                                        <Button>
                                                            <PersonIcon sx={{ color: "#000000" }} />
                                                        </Button>
                                                    </TableCell>
                                                    :
                                                    <TableCell align="center" width="6%" sx={{ pr: 0 }}>
                                                        <Button>
                                                            <PersonOffIcon sx={{ color: "#000000" }} />
                                                        </Button>
                                                    </TableCell>
                                                :
                                                row.delflg === 0 ?
                                                    <TableCell align="center" width="6%" sx={{ pr: 0 }}>
                                                        <Button>
                                                            <PersonOffIcon sx={{ color: "#000000" }} />
                                                        </Button>
                                                    </TableCell>
                                                    :
                                                    <TableCell align="center" width="6%" sx={{ pr: 0 }}>
                                                        <Button>
                                                            <PersonIcon sx={{ color: "#000000" }} />
                                                        </Button>
                                                    </TableCell>
                                        }
                                        <TableCell align="left" width="9%" sx={{ pr: 0 }}>{row.contractNo}</TableCell>
                                        {!editMode && row.delflg === 0 ?
                                            <TableCell align="left" width="12%" sx={{ pr: 0, fontWeight: "bold", wordBreak: 'break-word', color: "#289bdf" }}
                                                onClick={() => contractOnClick(row)}>
                                                <Button>
                                                    {row.contractName}
                                                </Button>
                                            </TableCell>
                                            :
                                            <TableCell align="left" width="12%" sx={{ pr: 0, wordBreak: 'break-word', }}>
                                                <Button sx={{ pr: 0, fontWeight: "normal", color: "#000000" }}>
                                                    {row.contractName}
                                                </Button>
                                            </TableCell>
                                        }

                                        <TableCell align="left" width="15%" sx={{ pr: 0 }}>{row.email}</TableCell>
                                        <TableCell align="left" width="10%" sx={{ pr: 0 }}>{row.companyName}</TableCell>
                                        <TableCell align="left" width="10%" sx={{ pr: 0 }}>{row.tantoShisyaName}</TableCell>
                                        <TableCell align="left" width="10%" sx={{ pr: 0 }}>{row.tellNumber}</TableCell>
                                        <TableCell align="left" width="10%" sx={{ pr: 0 }}>{row.validDate}</TableCell>
                                        <TableCell align="left" width="10%" sx={{ pr: 0 }}>{row.lastLoginDate}</TableCell>
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableFlame>
            {list &&
                Object.keys(list).length !== 0 ?
                <TablePagination
                    component="div"
                    count={list?.vendorInfoList?.length}
                    labelRowsPerPage="表示件数"
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 30, 50]}
                    page={page}
                    labelDisplayedRows={(from, to,
                        count = list?.vendorInfoList?.length) => (`全${count}件中　${from.from}件～${from.to === -1 ? from.count : from.to}件を表示  `)}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                : <Grid />
            }

            <Box sx={{ pb: 7 }} >
                <CssBaseline />
                <Paper sx={{ bottom: 0, left: 0, right: 0, background: 'transparent' }} elevation={0}>
                    <Grid item sx={{ mx: 2, my: 2 }} >
                        <GrayButton sx={{ fontSize: '1.2rem', px: 4, py: 1, mx: 2 }} onClick={() => onClickToBack()}>
                            <UndoIcon sx={{ mr: 1 }} />
                            戻る
                        </GrayButton>
                        <NomalButton sx={{ fontSize: '1.2rem', px: 4, py: 1, mx: 2 }} onClick={() => onClickToPropAssignment()}>
                            <AssignmentIndIcon sx={{ mr: 1 }} />
                            担当者割当画面
                        </NomalButton>
                    </Grid>
                </Paper>
            </Box>
        </InspectionContents>
    )
}